module.exports = __webpack_public_path__ + "img/tg-icon.1b505e7.svg";